// src/types/domain.ts
var DOMAINS = ["FEEDING", "CARE", "ILLNESS", "SLEEP", "EMERGENCY", "FAMILY"];
var DOMAIN_LABELS = {
  FEEDING: "\u5582\u517B",
  CARE: "\u65E5\u5E38\u62A4\u7406",
  ILLNESS: "\u75BE\u75C5\u4E0E\u4F53\u5F81",
  SLEEP: "\u7761\u7720\u4E0E\u5B89\u5168",
  EMERGENCY: "\u6025\u6551\u4E0E\u610F\u5916",
  FAMILY: "\u5988\u5988\u4E0E\u5BB6\u5EAD"
};
function isDomain(v) {
  return typeof v === "string" && DOMAINS.includes(v);
}

// src/types/stage.ts
var STAGES = ["PRENATAL", "M0_3", "M4_6", "M7_12", "Y1_2", "Y2_3"];
var STAGE_META = {
  PRENATAL: {
    subject: "\u5B55\u671F\u51C6\u5907",
    months: "\u5B55\u665A\u671F",
    focus: "\u5F85\u4EA7\u51C6\u5907\u4E0E\u5BB6\u5EAD\u534F\u4F5C",
    hint: "\u8FD8\u6CA1\u5378\u8D27\uFF0C\u5148\u628A\u7406\u8BBA\u8FC7\u4E00\u904D",
    minMonth: -1,
    maxMonth: -1
  },
  M0_3: {
    subject: "\u65B0\u751F\u513F\u7167\u62A4",
    months: "0\u20133 \u6708",
    focus: "\u5582\u517B\u3001\u7761\u7720\u4E0E\u65E5\u5E38\u7167\u62A4",
    hint: "\u6700\u624B\u5FD9\u811A\u4E71\u7684\u4E09\u4E2A\u6708",
    minMonth: 0,
    maxMonth: 3
  },
  M4_6: {
    subject: "\u8F85\u98DF\u542F\u8499",
    months: "4\u20136 \u6708",
    focus: "\u8F85\u98DF\u8D77\u6B65\u4E0E\u6210\u957F\u5B89\u5168",
    hint: "\u5F00\u59CB\u52A0\u8F85\u98DF\uFF0C\u4E5F\u5F00\u59CB\u4F1A\u7FFB\u8EAB",
    minMonth: 4,
    maxMonth: 6
  },
  M7_12: {
    subject: "\u6210\u957F\u5B89\u5168",
    months: "7\u201312 \u6708",
    focus: "\u722C\u884C\u63A2\u7D22\u4E0E\u610F\u5916\u9884\u9632",
    hint: "\u6EE1\u5730\u722C\u3001\u5230\u5904\u5543\u3001\u968F\u65F6\u7AD9\u8D77\u6765",
    minMonth: 7,
    maxMonth: 12
  },
  Y1_2: {
    subject: "\u5B66\u6B65\u7167\u62A4",
    months: "1\u20132 \u5C81",
    focus: "\u5B66\u6B65\u6210\u957F\u4E0E\u5C45\u5BB6\u5B89\u5168",
    hint: "\u4F1A\u8DD1\u4F1A\u722C\u4F1A\u5543\uFF0C\u610F\u5916\u4F24\u5BB3\u9AD8\u5CF0\u671F",
    minMonth: 13,
    maxMonth: 24
  },
  Y2_3: {
    subject: "\u60C5\u7EEA\u4E0E\u4E60\u60EF",
    months: "2\u20133 \u5C81",
    focus: "\u60C5\u7EEA\u5F15\u5BFC\u4E0E\u751F\u6D3B\u4E60\u60EF",
    hint: "\u5F00\u59CB\u8BB2\u9053\u7406\uFF0C\u4E5F\u5F00\u59CB\u4E0D\u8BB2\u9053\u7406",
    minMonth: 25,
    maxMonth: 36
  }
};
function stageLabel(stage) {
  const m = STAGE_META[stage];
  return `${m.months} \xB7 ${m.subject}`;
}
function isStage(v) {
  return typeof v === "string" && STAGES.includes(v);
}
function stageForMonths(months) {
  if (months == null || months < 0) return "PRENATAL";
  for (const stage of STAGES) {
    const meta = STAGE_META[stage];
    if (meta.minMonth >= 0 && months >= meta.minMonth && months <= meta.maxMonth) return stage;
  }
  return "Y2_3";
}
function monthsOfBaby(birthYear, birthMonth, now = /* @__PURE__ */ new Date()) {
  const months = (now.getFullYear() - birthYear) * 12 + (now.getMonth() + 1 - birthMonth);
  return months < 0 ? -1 : months;
}

// src/types/question.ts
var QUESTION_TYPES = [
  "JUDGE",
  "SINGLE",
  "MULTIPLE",
  "ORDER",
  "RISK_SPOT",
  "SCENARIO"
];
var QUESTION_TYPE_LABELS = {
  JUDGE: "\u5224\u65AD",
  SINGLE: "\u5355\u9009",
  MULTIPLE: "\u591A\u9009",
  ORDER: "\u6392\u5E8F",
  RISK_SPOT: "\u56FE\u7247\u627E\u98CE\u9669\u70B9",
  SCENARIO: "\u60C5\u666F\u51B3\u7B56\u94FE"
};
var QUESTION_DIFFICULTIES = [1, 2, 3];
var QUESTION_STATUSES = [
  "DRAFT",
  "PENDING_REVIEW",
  "REVIEWED",
  "ACTIVE",
  "ARCHIVED"
];
var QUESTION_STATUS_LABELS = {
  DRAFT: "\u8349\u7A3F",
  PENDING_REVIEW: "\u5F85\u590D\u6838",
  REVIEWED: "\u5DF2\u590D\u6838\u5F85\u4E0A\u67B6",
  ACTIVE: "\u5DF2\u4E0A\u67B6",
  ARCHIVED: "\u5DF2\u4E0B\u67B6"
};
var QUESTION_TRANSITIONS = {
  DRAFT: ["PENDING_REVIEW"],
  // 打回时回 DRAFT；复核通过进 REVIEWED
  PENDING_REVIEW: ["DRAFT", "REVIEWED"],
  // 复核后可上架；也可以再改（回 DRAFT）
  REVIEWED: ["ACTIVE", "DRAFT"],
  ACTIVE: ["ARCHIVED"],
  // 下架后可重新上架，也可以重新编辑
  ARCHIVED: ["ACTIVE", "DRAFT"]
};
function canTransition(from, to) {
  return QUESTION_TRANSITIONS[from].includes(to);
}
var REVISION_ACTIONS = [
  "CREATE",
  "SUBMIT_REVIEW",
  "APPROVE",
  "REJECT",
  "PUBLISH",
  "ARCHIVE",
  "EDIT",
  "IMPORT",
  "TICKET_ACCEPT"
];
function questionAnswers(question) {
  const answers = question.answers?.length ? question.answers : [question.answer];
  return question.type === "ORDER" || question.type === "SCENARIO" ? uniqueChoices(answers) : normalizeChoices(answers);
}
function answerChoices(answer, ordered = false) {
  const choices = answer.choices?.length ? answer.choices : [answer.choice];
  return ordered ? uniqueChoices(choices) : normalizeChoices(choices);
}
function isAnswerCorrect(question, answer) {
  if (!answer) return false;
  const expected = questionAnswers(question);
  const actual = answerChoices(answer, question.type === "ORDER" || question.type === "SCENARIO");
  return expected.length === actual.length && expected.every((choice, index) => choice === actual[index]);
}
function normalizeChoices(choices) {
  return uniqueChoices(choices).sort((left, right) => left - right);
}
function uniqueChoices(choices) {
  return [...new Set(choices)];
}

// src/types/cert.ts
var MEDALS = ["BRONZE", "SILVER", "GOLD"];
var MEDAL_LABELS = {
  BRONZE: "\u94DC",
  SILVER: "\u94F6",
  GOLD: "\u91D1"
};
var MEDAL_ICONS = {
  BRONZE: "\u{1F949}",
  SILVER: "\u{1F948}",
  GOLD: "\u{1F947}"
};
var MEDAL_RANK = { BRONZE: 1, SILVER: 2, GOLD: 3 };
var CERT_TYPES = ["SUBJECT", "FINAL", "MASTER"];
function certKeyOf(type, stage) {
  if (type === "SUBJECT") {
    if (!stage) throw new Error("SUBJECT \u8BC1\u4E66\u5FC5\u987B\u5E26 stage");
    return stage;
  }
  return type;
}
var CERT_META = {
  PRENATAL: { name: "\u5B55\u671F\u51C6\u5907\u8BC1", description: "\u5B55\u665A\u671F \xB7 \u5F85\u4EA7\u51C6\u5907\u4E0E\u5BB6\u5EAD\u534F\u4F5C" },
  M0_3: { name: "\u65B0\u751F\u513F\u7167\u62A4\u8BC1", description: "0\u20133 \u6708 \xB7 \u5582\u517B\u3001\u7761\u7720\u4E0E\u65E5\u5E38\u7167\u62A4" },
  M4_6: { name: "\u8F85\u98DF\u542F\u8499\u8BC1", description: "4\u20136 \u6708 \xB7 \u8F85\u98DF\u8D77\u6B65\u4E0E\u6210\u957F\u5B89\u5168" },
  M7_12: { name: "\u6210\u957F\u5B89\u5168\u8BC1", description: "7\u201312 \u6708 \xB7 \u722C\u884C\u63A2\u7D22\u4E0E\u610F\u5916\u9884\u9632" },
  Y1_2: { name: "\u5B66\u6B65\u7167\u62A4\u8BC1", description: "1\u20132 \u5C81 \xB7 \u5B66\u6B65\u6210\u957F\u4E0E\u5C45\u5BB6\u5B89\u5168" },
  Y2_3: { name: "\u60C5\u7EEA\u4E0E\u4E60\u60EF\u8BC1", description: "2\u20133 \u5C81 \xB7 \u60C5\u7EEA\u5F15\u5BFC\u4E0E\u751F\u6D3B\u4E60\u60EF" },
  FINAL: {
    name: "\u7EFC\u5408\u5927\u8003\u8BC1\u4E66",
    description: "\u5168\u6708\u9F84 \xB7 \u7EFC\u5408\u80B2\u513F\u77E5\u8BC6",
    unlockHint: "\u62FF\u5230\u4EFB\u610F 3 \u672C\u9636\u6BB5\u8BC1\u4E66\u540E\u89E3\u9501"
  },
  MASTER: {
    name: "\u5168\u80FD\u80B2\u513F\u5BB6\u957F\u8BC1\u4E66",
    description: "\u516D\u4E2A\u6210\u957F\u9636\u6BB5 \xB7 \u5168\u90E8\u91D1\u8BC1",
    unlockHint: "\u96C6\u9F50 6 \u672C\u91D1\u8BC1\u540E\u81EA\u52A8\u9881\u53D1"
  }
};
var CERT_SLOGAN = "\u6210\u957F \xB7 \u8BB0\u5F55 \xB7 \u6BCF\u4E00\u6B65";

// src/types/exam.ts
var EXAM_MODES = ["SUBJECT", "FINAL", "ENDLESS", "DAILY", "REVIEW", "PRACTICE"];
var EXAM_MODE_LABELS = {
  SUBJECT: "\u79D1\u76EE\u8003\u8BD5",
  FINAL: "\u7EFC\u5408\u5927\u8003",
  ENDLESS: "\u65E0\u9650\u95EF\u5173",
  DAILY: "\u6BCF\u65E5\u4E00\u9898",
  REVIEW: "\u9519\u9898\u91CD\u7EC3",
  PRACTICE: "\u4E13\u9879\u8BAD\u7EC3"
};
var CHALLENGE_MODES = ["OPEN", "DUEL"];

// src/constants.ts
var PAPER_SIZE = 20;
var FINAL_EXAM_SIZE = 25;
var MEDAL_ALLOWED_WRONG = {
  BRONZE: 2,
  SILVER: 1,
  GOLD: 0
};
var PASS_ALLOWED_WRONG = MEDAL_ALLOWED_WRONG.BRONZE;
var DOMAIN_QUOTA = {
  // 待产包、产后准备、家庭分工、产后情绪 —— 这个阶段家庭关系是主战场
  PRENATAL: { FEEDING: 4, CARE: 3, ILLNESS: 4, SLEEP: 2, EMERGENCY: 2, FAMILY: 5 },
  // 脐带、黄疸、洗澡、剪指甲、囟门，全挤在这三个月
  M0_3: { FEEDING: 5, CARE: 5, ILLNESS: 4, SLEEP: 3, EMERGENCY: 2, FAMILY: 1 },
  // 辅食起步是这个阶段压倒性的头等大事
  M4_6: { FEEDING: 6, CARE: 3, ILLNESS: 3, SLEEP: 3, EMERGENCY: 3, FAMILY: 2 },
  // 手指食物噎呛 + 学步跌倒开始高发
  M7_12: { FEEDING: 5, CARE: 3, ILLNESS: 3, SLEEP: 3, EMERGENCY: 4, FAMILY: 2 },
  // 误吞、烫伤、坠落、溺水 —— 1–2 岁是儿童意外伤害的高峰期
  Y1_2: { FEEDING: 4, CARE: 3, ILLNESS: 3, SLEEP: 2, EMERGENCY: 6, FAMILY: 2 },
  // 发脾气、入园焦虑、社交冲突成为主要困扰，同时安全风险仍高
  Y2_3: { FEEDING: 3, CARE: 3, ILLNESS: 3, SLEEP: 2, EMERGENCY: 5, FAMILY: 4 }
};
var FINAL_EXAM_QUOTA = {
  FEEDING: 6,
  CARE: 5,
  ILLNESS: 4,
  SLEEP: 4,
  EMERGENCY: 4,
  FAMILY: 2
};
var SUBJECT_EXAM_DIFFICULTY_QUOTA = { 1: 3, 2: 11, 3: 6 };
var FINAL_EXAM_DIFFICULTY_QUOTA = { 1: 3, 2: 13, 3: 9 };
var SUBJECT_EXAM_TYPE_QUOTA = { JUDGE: 3, SINGLE: 12, MULTIPLE: 5 };
var FINAL_EXAM_TYPE_QUOTA = { JUDGE: 4, SINGLE: 15, MULTIPLE: 6 };
var QUESTION_COVERAGE_TARGETS = {
  stagePool: 300,
  stageExclusive: 200,
  domain: 50,
  difficulty: 50
};
var RECENT_PAPERS_FOR_DEDUPE = 3;
var STAGE_EXCLUSIVE_MIN = 14;
var FINAL_EXAM_UNLOCK_CERTS = 3;
var MASTER_GOLD_REQUIRED = 6;
var CERT_SCORE = { BRONZE: 1, SILVER: 2, GOLD: 3 };
var FINAL_CERT_MULTIPLIER = 2;
var MASTER_CERT_BONUS = 10;
var MAX_CERT_SCORE = 6 * CERT_SCORE.GOLD + CERT_SCORE.GOLD * FINAL_CERT_MULTIPLIER + MASTER_CERT_BONUS;
var ENDLESS_MAX_WRONG = 3;
var ENDLESS_DIFFICULTY_STEPS = [
  [1, 1],
  [11, 2],
  [26, 3]
];
var ENDLESS_MILESTONE_STEP = 10;
var DAILY_REUSE_GAP_DAYS = 90;
var WRONGBOOK_MASTER_STREAK = 2;
var FINAL_EXAM_DAILY_LIMIT = 3;
var PAPER_DAILY_LIMIT = 30;
var MIN_SAMPLE_FOR_STATS = 30;
var FALLBACK_WRONG_RATE_TRAP = 0.62;
var FALLBACK_WRONG_RATE_NORMAL = 0.35;
var POSTER_WIDTH = 750;
var POSTER_HEIGHT = 1334;
var QR_SIZE = 176;
var CHALLENGE_TTL = 7 * 24 * 60 * 60 * 1e3;
var DEFAULT_STAGE = "M0_3";
var MAX_FRIENDS = 200;
var SUBSCRIBE_DAILY_LIMIT = 1;
var DISCLAIMER = "\u672C\u6D4B\u8BD5\u4E3A\u5A31\u4E50\u79D1\u666E\u6027\u8D28\uFF0C\u4E0D\u6784\u6210\u533B\u7597\u5EFA\u8BAE";
var DISCLAIMER_ITEM = "\u672C\u5185\u5BB9\u4EC5\u4F9B\u53C2\u8003\uFF0C\u5B9D\u5B9D\u51FA\u73B0\u5F02\u5E38\u8BF7\u53CA\u65F6\u5C31\u533B";

// src/scoring.ts
var TIER_DEFS = {
  perfect: { tier: "perfect", title: "\u80B2\u513F\u6EE1\u5206\u9009\u624B", poster: "pass" },
  pass: { tier: "pass", title: "\u80B2\u513F\u8FDB\u9636\u5BB6\u957F", poster: "pass" },
  near: { tier: "near", title: "\u5C31\u5DEE\u4E00\u70B9", poster: "fail" },
  fail: { tier: "fail", title: "\u7EE7\u7EED\u7EC3\u4E60\u5BB6\u957F", poster: "fail" },
  badfail: { tier: "badfail", title: "\u65B0\u624B\u7EC3\u4E60\u751F", poster: "badfail" }
};
function calcScore(total, correctCount) {
  if (total <= 0) return 0;
  return Math.round(correctCount / total * 100);
}
function gradePaper(questions, answers) {
  const map = new Map(answers.map((answer) => [answer.questionId, answer]));
  let correctCount = 0;
  for (const q of questions) {
    if (isAnswerCorrect(q, map.get(q.id))) correctCount++;
  }
  return {
    correctCount,
    wrongCount: questions.length - correctCount,
    score: calcScore(questions.length, correctCount)
  };
}
function getTier(score, wrongCount) {
  if (wrongCount === 0) return TIER_DEFS.perfect;
  if (wrongCount <= PASS_ALLOWED_WRONG) return TIER_DEFS.pass;
  if (score >= 75) return TIER_DEFS.near;
  if (score >= 60) return TIER_DEFS.fail;
  return TIER_DEFS.badfail;
}
function getTitle(score, wrongCount) {
  return getTier(score, wrongCount).title;
}
function isPassed(wrongCount) {
  return wrongCount <= PASS_ALLOWED_WRONG;
}
function judgeMedal(wrongCount, rules = MEDAL_ALLOWED_WRONG) {
  for (let i = MEDALS.length - 1; i >= 0; i--) {
    const medal = MEDALS[i];
    if (wrongCount <= rules[medal]) return medal;
  }
  return null;
}
function passScoreFor(total) {
  return calcScore(total, total - PASS_ALLOWED_WRONG);
}
function formatDuration(ms) {
  const total = Math.max(0, Math.round(ms / 1e3));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}'${String(s).padStart(2, "0")}"`;
}
function pickBySeed(seed, list) {
  if (list.length === 0) throw new Error("pickBySeed: \u7A7A\u6570\u7EC4");
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return list[Math.abs(h) % list.length];
}

// src/cert.ts
function isStageCert(key) {
  return STAGES.includes(key);
}
function shouldUpgrade(current, next) {
  if (!current) return true;
  return MEDAL_RANK[next] > MEDAL_RANK[current];
}
function calcCertScore(certs) {
  let score = 0;
  for (const c of certs) {
    if (c.type === "MASTER") {
      score += MASTER_CERT_BONUS;
    } else if (c.type === "FINAL") {
      score += CERT_SCORE[c.medal] * FINAL_CERT_MULTIPLIER;
    } else {
      score += CERT_SCORE[c.medal];
    }
  }
  return score;
}
function canUnlockFinalExam(certs) {
  return countStageCerts(certs) >= FINAL_EXAM_UNLOCK_CERTS;
}
function canUnlockMasterCert(certs) {
  const golds = certs.filter((c) => c.type === "SUBJECT" && c.medal === "GOLD");
  return golds.length >= MASTER_GOLD_REQUIRED;
}
function countStageCerts(certs) {
  return certs.filter((c) => c.type === "SUBJECT").length;
}
function certsUntilFinalExam(certs) {
  return Math.max(0, FINAL_EXAM_UNLOCK_CERTS - countStageCerts(certs));
}
function encodeRankScore(certScore, achievedAt) {
  return certScore * 1e10 + (1e10 - achievedAt / 1e3);
}

// src/copy/roasts.ts
var ROASTS = {
  badfail: {
    poster: [
      "\u8FD9\u6B21\u4E0D\u4F1A\u7684\uFF0C\u6B63\u597D\u73B0\u5728\u5B66\u4F1A",
      "\u5EFA\u8BAE\u8FD9\u672C\u8BC1\u5148\u522B\u9886\u4E86\uFF0C\u56DE\u53BB\u518D\u7EC3\u4E24\u5E74",
      "\u5B9D\u5B9D\uFF1A\u6211\u4E0D\u662F\u9488\u5BF9\u8C01",
      "\u606D\u559C\u89E3\u9501\u6210\u5C31\u300C\u5168\u9760\u961F\u53CB\u5E26\u300D",
      "\u8FD9\u4E2A\u6210\u7EE9\uFF0C\u6708\u5AC2\u770B\u4E86\u4F1A\u6C89\u9ED8"
    ],
    result: [
      "\u522B\u614C\uFF0C\u4F60\u4E0D\u662F\u4E0D\u7231\u5B69\u5B50\uFF0C\u53EA\u662F\u8FD9\u4E9B\u77E5\u8BC6\u4EE5\u524D\u6CA1\u4EBA\u7CFB\u7EDF\u6559\u8FC7\u3002",
      "\u597D\u6D88\u606F\uFF1A\u9519\u7684\u90FD\u80FD\u6539\u3002\u574F\u6D88\u606F\uFF1A\u4F60\u9519\u5F97\u6709\u70B9\u591A\u3002",
      "\u8FD9\u4E2A\u5206\u6570\u8BF4\u660E\u4E0D\u4E86\u4F60\u662F\u4E2A\u574F\u7238\u5988\uFF0C\u53EA\u8BF4\u660E\u4F60\u8BE5\u770B\u770B\u4E0B\u9762\u7684\u9519\u9898\u3002",
      "\u7B2C\u4E00\u6B21\u5E26\u5A03\u8003\u7838\u5F88\u6B63\u5E38\uFF0C\u6BD5\u7ADF\u8FD9\u79D1\u76EE\u6CA1\u4EBA\u6559\u8FC7\u4F60\u3002",
      "\u628A\u9519\u9898\u770B\u5B8C\uFF0C\u4F60\u5C31\u80FD\u8D85\u8FC7\u521A\u624D\u7684\u81EA\u5DF1 40 \u5206\u3002"
    ]
  },
  fail: {
    poster: [
      "\u518D\u8BA4\u771F\u770B\u4E24\u9898\u5C31\u80FD\u8FC7",
      "\u79BB\u53CA\u683C\u771F\u7684\u53EA\u5DEE\u4E00\u70B9",
      "\u7406\u8BBA\u9760\u731C\uFF0C\u5B9E\u64CD\u51ED\u624B\u611F",
      "\u57FA\u7840\u6709\u4E86\uFF0C\u5173\u952E\u7EC6\u8282\u8FD8\u8981\u8865",
      "\u4F60\u4E0D\u662F\u4E0D\u4F1A\u5E26\u5A03\uFF0C\u4F60\u53EA\u662F\u6BCF\u6B21\u90FD\u5DEE\u4E00\u70B9"
    ],
    result: [
      "\u5DEE\u4E00\u70B9\uFF0C\u4F46\u5DEE\u7684\u8FD9\u4E00\u70B9\u6070\u597D\u90FD\u5728\u5173\u952E\u9898\u4E0A\u3002",
      "\u57FA\u7840\u8FD8\u5728\uFF0C\u8865\u4E24\u4E2A\u77E5\u8BC6\u70B9\u5C31\u80FD\u8FC7\u3002",
      "\u4F60\u5DF2\u7ECF\u6BD4\u300C\u4EC0\u4E48\u90FD\u4E0D\u77E5\u9053\u300D\u5F3A\u5F88\u591A\u4E86\uFF0C\u5C31\u662F\u8FD8\u4E0D\u591F\u7A33\u3002",
      "\u8865\u8003\u8D39\u6211\u5E2E\u4F60\u51C6\u5907\u597D\u4E86\uFF0C\u4E0B\u6B21\u4E00\u5B9A\u3002",
      "\u770B\u5B8C\u9519\u9898\u518D\u8003\u4E00\u6B21\uFF0C\u8FD9\u6B21\u5927\u6982\u7387\u80FD\u62FF\u672C\u3002"
    ]
  },
  near: {
    poster: [
      "\u5DEE\u4E00\u70B9\u5C31\u80FD\u62FF\u5230\u8BC1\u4E66",
      "\u4E00\u4E2A\u8BA9\u4EBA\u60CB\u60DC\u7684\u6210\u7EE9",
      "\u5DF2\u7ECF\u5F88\u7A33\uFF0C\u518D\u7EC6\u5FC3\u4E00\u70B9",
      "\u5C31\u5DEE\u4E34\u95E8\u4E00\u811A",
      "\u6BD4\u5927\u591A\u6570\u961F\u53CB\u5F3A\uFF0C\u4F46\u8FD8\u6CA1\u5F3A\u5230\u80FD\u5439"
    ],
    result: [
      "\u5C31\u5DEE\u4E00\u4E24\u9898\uFF0C\u683D\u5728\u4E86\u9001\u5206\u9898\u4E0A\uFF0C\u6709\u70B9\u53EF\u60DC\u3002",
      "\u4F60\u7684\u80B2\u513F\u5E38\u8BC6\u5DF2\u7ECF\u5728\u5E73\u5747\u7EBF\u4EE5\u4E0A\u4E86\uFF0C\u5C31\u5DEE\u6700\u540E\u90A3\u70B9\u4E25\u8C28\u3002",
      "\u8FD9\u4E2A\u5206\u6570\u653E\u5728\u7238\u7238\u7FA4\u91CC\u5DF2\u7ECF\u80FD\u6392\u524D\u5217\u4E86\u3002",
      "\u518D\u770B\u4E00\u773C\u9519\u9898\uFF0C\u4E0B\u6B21\u6EE1\u5206\u4E0D\u662F\u95EE\u9898\u3002",
      "\u79BB\u62FF\u672C\u53EA\u6709\u4E00\u6B65\uFF0C\u8FD9\u4E00\u6B65\u503C\u5F97\u4F60\u82B1\u4E09\u5206\u949F\u3002"
    ]
  },
  pass: {
    poster: [
      "\u987A\u5229\u62FF\u8BC1\uFF0C\u5E26\u5A03\u66F4\u6709\u5E95\u6C14",
      "\u5B9D\u5B9D\u7684\u5B89\u5168\u611F +1",
      "\u8FD9\u4E2A\u5206\u6570\u53EF\u4EE5\u5728\u5BB6\u65CF\u7FA4\u91CC\u6A2A\u7740\u8D70",
      "\u7A33\uFF0C\u662F\u771F\u7684\u7A33",
      "\u5173\u952E\u80B2\u513F\u77E5\u8BC6\u5DF2\u7ECF\u638C\u63E1"
    ],
    result: [
      "\u606D\u559C\u901A\u8FC7\uFF0C\u4F60\u662F\u90A3\u79CD\u80FD\u8BA9\u961F\u53CB\u5B89\u5FC3\u7761\u6574\u89C9\u7684\u5BB6\u957F\u3002",
      "\u53CA\u683C\u7EBF\u4EE5\u4E0A\uFF0C\u8BF4\u660E\u4F60\u662F\u771F\u7684\u5728\u8BA4\u771F\u5B66\uFF0C\u4E0D\u662F\u5728\u778E\u5E26\u3002",
      "\u62FF\u8BC1\u4E86\u3002\u63A5\u4E0B\u6765\u628A\u8FD9\u4E9B\u77E5\u8BC6\u6162\u6162\u7528\u8FDB\u65E5\u5E38\u3002",
      "\u8FD9\u4E2A\u6210\u7EE9\uFF0C\u53EF\u4EE5\u7406\u76F4\u6C14\u58EE\u5730\u7EA0\u6B63\u957F\u8F88\u4E86\u3002",
      "\u4F60\u5DF2\u7ECF\u6BD4\u5927\u90E8\u5206\u65B0\u624B\u7238\u5988\u66F4\u61C2\u600E\u4E48\u4FDD\u62A4\u5B69\u5B50\u4E86\u3002"
    ]
  },
  perfect: {
    poster: [
      "\u6EE1\u5206\uFF0C\u4F60\u5C31\u662F\u5BB6\u91CC\u7684\u80B2\u513F\u8BF4\u660E\u4E66",
      "\u6EE1\u5206\u9009\u624B\uFF0C\u80B2\u513F\u77E5\u8BC6\u771F\u624E\u5B9E",
      "100 \u5206\uFF0C\u5B9D\u5B9D\u4F55\u5FB7\u4F55\u80FD",
      "\u65E0\u53EF\u6311\u5254\uFF0C\u8FD9\u672C\u8BC1\u5B9E\u81F3\u540D\u5F52",
      "\u6EE1\u5206\u901A\u8FC7\uFF0C\u5EFA\u8BAE\u5168\u5BB6\u5411\u4F60\u770B\u9F50"
    ],
    result: [
      "\u6EE1\u5206\u3002\u8FD9\u4E2A\u9886\u57DF\u4F60\u5DF2\u7ECF\u4E0D\u9700\u8981\u522B\u4EBA\u6559\u4E86\u3002",
      "\u4E00\u9898\u6CA1\u9519\u3002\u4F60\u5BB6\u5B9D\u5B9D\u8FD0\u6C14\u662F\u771F\u7684\u597D\u3002",
      "\u6EE1\u5206\u9009\u624B\uFF0C\u5EFA\u8BAE\u628A\u8FD9\u5F20\u56FE\u7ED9\u4F60\u5BB6\u957F\u8F88\u770B\u770B\u3002",
      "\u4F60\u4E0D\u4EC5\u4F1A\u5E26\u5A03\uFF0C\u4F60\u8FD8\u77E5\u9053\u4E3A\u4EC0\u4E48\u8FD9\u4E48\u5E26\u3002",
      "\u5B8C\u7F8E\u901A\u8FC7\u3002\u5269\u4E0B\u7684\uFF0C\u5C31\u4EA4\u7ED9\u5B9E\u6218\u4E86\u3002"
    ]
  }
};
var CERT_COPY = {
  BRONZE: [
    "\u94DC\u8BC1\u5230\u624B\u3002\u8FD9\u672C\u8BC1\u7684\u542B\u91D1\u91CF\uFF0C\u53D6\u51B3\u4E8E\u4F60\u4E0B\u6B21\u8003\u591A\u5C11\u5206\u3002",
    "\u538B\u7EBF\u901A\u8FC7\uFF0C\u4F46\u901A\u8FC7\u5C31\u662F\u901A\u8FC7\u3002",
    "\u606D\u559C\u9886\u8BC1\u3002\u94DC\u7684\uFF0C\u4F46\u4E5F\u662F\u8BC1\u3002"
  ],
  SILVER: [
    "\u94F6\u8BC1\u3002\u5C31\u5DEE\u4E00\u9898\uFF0C\u770B\u5F97\u51FA\u6765\u662F\u771F\u4F1A\u3002",
    "\u518D\u5BF9\u4E00\u9898\u5C31\u662F\u91D1\u8BC1\u4E86 \u2014\u2014 \u8FD9\u8BDD\u6211\u8BF4\u5F97\u51FA\u53E3\uFF0C\u4F60\u542C\u7740\u4E5F\u96BE\u53D7\u3002",
    "\u94F6\u8BC1\u5230\u624B\uFF0C\u79BB\u6EE1\u5206\u53EA\u5269\u4E00\u6B65\u3002"
  ],
  GOLD: [
    "\u91D1\u8BC1\u3002\u8FD9\u4E00\u79D1\u4F60\u5DF2\u7ECF\u6CA1\u6709\u53EF\u6311\u5254\u7684\u4E86\u3002",
    "\u5168\u5BF9\u3002\u8FD9\u672C\u91D1\u8BC1\u662F\u5B9E\u6253\u5B9E\u7684\u3002",
    "\u91D1\u8BC1\u5165\u8D26\u3002\u8BC1\u4E66\u5899\u4E0A\u53C8\u4EAE\u4E86\u4E00\u683C\u3002"
  ]
};
var MASTER_CERT_COPY = [
  "\u516D\u672C\u91D1\u8BC1\u96C6\u9F50\u3002\u5168\u80FD\u80B2\u513F\u5BB6\u957F\uFF0C\u5168\u7AD9\u6CA1\u51E0\u4E2A\u4EBA\u3002",
  "\u4F60\u628A\u8FD9\u5957\u9898\u505A\u5230\u5934\u4E86\u3002\u8FD9\u672C\u8BC1\u6CA1\u6709\u66F4\u9AD8\u7684\u4E86\u3002"
];
var BATTLE_COPY = {
  win: [
    "\u606D\u559C\u4F60\u4EE5 {diff} \u5206\u4F18\u52BF\u78BE\u538B\u961F\u53CB",
    "\u8FD9\u4E2A\u5BB6\u7684\u80B2\u513F\u4E3B\u529B\uFF0C\u5B9E\u81F3\u540D\u5F52",
    "\u4F60\u8D62\u4E86\uFF0C\u800C\u4E14\u8D62\u5F97\u6BEB\u65E0\u60AC\u5FF5"
  ],
  lose: ["\u8F93\u4E86 {diff} \u5206\uFF0C\u4ECA\u665A\u7684\u591C\u5976\u4F60\u6765\u5427", "\u961F\u53CB\u6280\u9AD8\u4E00\u7B79\uFF0C\u865A\u5FC3\u5B66\u4E60", "\u5DEE {diff} \u5206\uFF0C\u660E\u5929\u518D\u6218"],
  draw: ["\u5E73\u5C40\u3002\u770B\u6765\u4F60\u4FE9\u662F\u4E00\u8D77\u778E\u5E26\u7684", "\u6253\u6210\u5E73\u624B\uFF0C\u5EFA\u8BAE\u4E00\u8D77\u56DE\u7089"]
};
var ENDLESS_COPY = {
  /** 连对数低于 10 */
  short: ["\u4E09\u6B21\u673A\u4F1A\uFF0C\u6CA1\u6491\u8FC7\u5341\u9898\u3002", "\u8FD9\u4E2A\u8FDE\u5BF9\u6570\uFF0C\u5EFA\u8BAE\u5148\u505A\u4E00\u6B21\u9636\u6BB5\u7EC3\u4E60\u3002"],
  /** 10–29 */
  mid: ["\u8FDE\u5BF9 {streak} \u9898\uFF0C\u7A33\u4F4F\u4E86\u3002", "{streak} \u8FDE\u5BF9\uFF0C\u80FD\u770B\u51FA\u662F\u5E26\u8FC7\u5A03\u7684\u3002"],
  /** 30+ */
  long: ["\u8FDE\u5BF9 {streak} \u9898\u3002\u8FD9\u5DF2\u7ECF\u4E0D\u662F\u8FD0\u6C14\u4E86\u3002", "{streak} \u8FDE\u5BF9\uFF0C\u9898\u5E93\u5FEB\u88AB\u4F60\u6253\u7A7F\u4E86\u3002"]
};
var EMPTY_COPY = {
  noFriends: "\u8FD8\u6CA1\u6709\u8003\u53CB\u3002\u8003\u53CB\u662F\u4ECE\u4F60\u5206\u4EAB\u51FA\u53BB\u7684\u6210\u7EE9\u91CC\u81EA\u7136\u6765\u7684\uFF0C\u4E0D\u7528\u523B\u610F\u53BB\u51D1\u3002",
  noWrongbook: "\u9519\u9898\u672C\u662F\u7A7A\u7684\u3002\u8981\u4E48\u4F60\u662F\u771F\u7684\u5F3A\uFF0C\u8981\u4E48\u4F60\u8FD8\u6CA1\u8003\u8FC7\u51E0\u6B21\u3002",
  noCert: "\u8BC1\u4E66\u5899\u8FD8\u662F\u7A7A\u7684\u3002\u6311\u4E00\u4E2A\u79D1\u76EE\u5F00\u59CB\u5427\uFF0C\u7B2C\u4E00\u672C\u8BC1\u6700\u597D\u62FF\u3002"
};
var LANDING_HOOKS = [
  "90% \u7684\u65B0\u624B\u7238\u7238\uFF0C\u7B2C\u4E00\u9898\u5C31\u7B54\u9519\u4E86",
  "\u4F60\u4EE5\u4E3A\u4F60\u4F1A\u5E26\u5A03\uFF0C\u76F4\u5230\u4F60\u505A\u4E86\u8FD9\u5957\u9898",
  "20 \u9053\u9898\uFF0C\u6D4B\u6D4B\u4F60\u6709\u6CA1\u6709\u8D44\u683C\u72EC\u81EA\u5E26\u5A03"
];

// src/copy/home-greetings.ts
var HOME_GREETINGS = {
  morning: [
    "\u65E9\u4E0A\u597D\uFF0C\u80B2\u513F\u77E5\u8BC6\u4E5F\u8981\u8D81\u70ED\u5B66",
    "\u65B0\u7684\u4E00\u5929\uFF0C\u5148\u7ED9\u5E26\u5A03\u5E95\u6C14\u52A0\u4E00\u70B9",
    "\u65E9\u5B89\uFF0C\u5148\u7528\u4E00\u9898\u628A\u80B2\u513F\u8111\u888B\u53EB\u9192",
    "\u6668\u5149\u5230\u4F4D\uFF0C\u4ECA\u5929\u7684\u77E5\u8BC6\u70B9\u4E5F\u6765\u62A5\u5230",
    "\u65E9\u8D77\u5B66\u4E00\u70B9\uFF0C\u767D\u5929\u9047\u4E8B\u66F4\u4ECE\u5BB9",
    "\u65B0\u7684\u4E00\u5929\uFF0C\u4ECE\u4E00\u4E2A\u9760\u8C31\u5224\u65AD\u5F00\u59CB",
    "\u65E9\u4E0A\u597D\uFF0C\u5148\u6512\u4E00\u70B9\u4ECA\u5929\u7684\u5E26\u5A03\u5E95\u6C14",
    "\u6E05\u9192\u7684\u4E0D\u53EA\u662F\u5496\u5561\uFF0C\u8FD8\u6709\u80B2\u513F\u601D\u8DEF",
    "\u8D81\u65E9\u6668\u8111\u888B\u5728\u7EBF\uFF0C\u987A\u624B\u62FF\u4E0B\u4E00\u9898",
    "\u4ECA\u65E5\u4EFD\u5B66\u4E60\u5F00\u95E8\uFF0C\u6162\u6162\u6765\u5C31\u5F88\u7A33"
  ],
  afternoon: [
    "\u5348\u540E\u5237\u4E00\u9898\uFF0C\u4ECA\u5929\u53C8\u591A\u4F1A\u4E00\u70B9",
    "\u5FD9\u91CC\u5077\u95F2\uFF0C\u4E5F\u80FD\u7ED9\u77E5\u8BC6\u5145\u4E2A\u7535",
    "\u4E0B\u5348\u597D\uFF0C\u7ED9\u5FD9\u788C\u6309\u4E2A\u6682\u505C\uFF0C\u5B66\u4E00\u5C0F\u70B9",
    "\u5348\u540E\u8111\u888B\u6709\u70B9\u56F0\uFF1F\u6765\u9053\u9898\u9192\u9192\u795E",
    "\u62BD\u7A7A\u7EC3\u4E00\u9898\uFF0C\u628A\u788E\u7247\u65F6\u95F4\u53D8\u6210\u5E95\u6C14",
    "\u4ECA\u5929\u8FC7\u534A\uFF0C\u77E5\u8BC6\u8FDB\u5EA6\u4E5F\u6DFB\u4E0A\u4E00\u683C",
    "\u624B\u8FB9\u4E8B\u60C5\u518D\u591A\uFF0C\u4E5F\u80FD\u7559\u4E00\u5206\u949F\u7ED9\u81EA\u5DF1",
    "\u5348\u540E\u5145\u7535\u7AD9\u5DF2\u5F00\uFF0C\u8FDB\u6765\u8865\u4E00\u70B9\u77E5\u8BC6",
    "\u5FD9\u5B8C\u8FD9\u4E00\u9635\uFF0C\u987A\u624B\u5E26\u8D70\u4E00\u4E2A\u77E5\u8BC6\u70B9",
    "\u4E0D\u7528\u6574\u5757\u65F6\u95F4\uFF0C\u4E00\u9053\u9898\u4E5F\u7B97\u8BA4\u771F\u5B66\u4E60"
  ],
  evening: [
    "\u665A\u4E0A\u597D\uFF0C\u4ECA\u5929\u4E5F\u7ED9\u81EA\u5DF1\u52A0\u4E00\u70B9\u5206",
    "\u5A03\u7761\u4E86\u6CA1\uFF1F\u77E5\u8BC6\u70B9\u8FD8\u9192\u7740",
    "\u591C\u91CC\u5B89\u9759\u4E00\u70B9\uFF0C\u6B63\u9002\u5408\u6361\u4E2A\u77E5\u8BC6\u70B9",
    "\u4ECA\u5929\u8F9B\u82E6\u4E86\uFF0C\u518D\u5B66\u4E00\u70B9\u5C31\u5B89\u5FC3\u6536\u5DE5",
    "\u665A\u95F4\u5C0F\u7EC3\u4E60\uFF0C\u7ED9\u660E\u5929\u591A\u5907\u4E00\u4EFD\u4ECE\u5BB9",
    "\u4E00\u5929\u5FEB\u7ED3\u675F\uFF0C\u7ED9\u81EA\u5DF1\u7684\u6210\u957F\u7559\u4E2A\u8BB0\u5F55",
    "\u591C\u6DF1\u4E0D\u8D76\u8FDB\u5EA6\uFF0C\u8F7B\u677E\u770B\u4E00\u9898\u5C31\u597D",
    "\u665A\u4E0A\u6765\u7B7E\u5230\uFF0C\u4ECA\u5929\u7684\u77E5\u8BC6\u522B\u7559\u7A7A",
    "\u5B9D\u5B9D\u8FDB\u5165\u591C\u95F4\u6A21\u5F0F\uFF0C\u7238\u5988\u5F00\u542F\u8F7B\u5B66\u4E60",
    "\u7761\u524D\u4E0D\u5237\u7126\u8651\uFF0C\u5237\u4E00\u9053\u9760\u8C31\u7684\u9898"
  ],
  resume: [
    "\u4E0A\u6B21\u7684\u8FDB\u5EA6\u8FD8\u5728\uFF0C\u63A5\u7740\u7B54\u66F4\u7701\u5FC3",
    "\u7B54\u6848\u8FD8\u5728\u539F\u5730\uFF0C\u7B49\u4F60\u56DE\u6765\u7EE7\u7EED",
    "\u8FDB\u5EA6\u5DF2\u7ECF\u4FDD\u5B58\uFF0C\u56DE\u6765\u5C31\u4ECE\u719F\u6089\u7684\u5730\u65B9\u5F00\u59CB",
    "\u521A\u624D\u7B54\u5230\u4E00\u534A\uFF0C\u73B0\u5728\u63A5\u4E0A\u6B63\u5408\u9002",
    "\u4E0D\u7528\u91CD\u5934\u518D\u6765\uFF0C\u7EE7\u7EED\u5B8C\u6210\u5269\u4E0B\u7684\u9898",
    "\u4E0A\u6B21\u7559\u4E86\u4E2A\u5C0F\u5C3E\u5DF4\uFF0C\u4ECA\u5929\u987A\u624B\u6536\u597D",
    "\u4E2D\u65AD\u4E0D\u7B97\u653E\u5F03\uFF0C\u63A5\u7740\u7B54\u5C31\u8FD8\u662F\u5B8C\u6574\u4E00\u573A",
    "\u9898\u76EE\u66FF\u4F60\u5B88\u7740\u8FDB\u5EA6\uFF0C\u968F\u65F6\u53EF\u4EE5\u7EE7\u7EED",
    "\u5DF2\u5B8C\u6210\u7684\u90FD\u7B97\u6570\uFF0C\u5269\u4E0B\u7684\u6162\u6162\u7B54",
    "\u56DE\u6765\u5F97\u521A\u597D\uFF0C\u8FD9\u573A\u8003\u8BD5\u8FD8\u5728\u7B49\u4F60\u5B8C\u6210"
  ],
  wrongbook: [
    "\u9519\u9898\u6392\u961F\u7533\u8BF7\u91CD\u65B0\u8BA4\u8BC6\u4F60",
    "\u4F1A\u9519\u4E0D\u53EF\u6015\uFF0C\u4F1A\u6539\u5C31\u5F88\u5389\u5BB3",
    "\u9519\u8FC7\u4E00\u6B21\u7684\u77E5\u8BC6\u70B9\uFF0C\u8FD9\u6B21\u6362\u4E2A\u65B9\u5F0F\u8BB0\u4F4F",
    "\u9519\u9898\u4E0D\u662F\u9ED1\u5386\u53F2\uFF0C\u662F\u4E0B\u4E00\u6B21\u7B54\u5BF9\u7684\u63D0\u793A",
    "\u4ECA\u5929\u56DE\u770B\u4E00\u9898\uFF0C\u660E\u5929\u5C31\u5C11\u8E29\u4E00\u4E2A\u5751",
    "\u628A\u4E0D\u4F1A\u7684\u6311\u51FA\u6765\uFF0C\u8FDB\u6B65\u4F1A\u66F4\u6709\u65B9\u5411",
    "\u7B54\u9519\u53EA\u662F\u53CD\u9988\uFF0C\u4E0D\u662F\u80FD\u529B\u5224\u5B9A",
    "\u548C\u9519\u9898\u518D\u89C1\u4E00\u9762\uFF0C\u8FD9\u6B21\u4E89\u53D6\u804A\u660E\u767D",
    "\u672A\u653B\u514B\u7684\u9898\u4E0D\u7740\u6025\uFF0C\u4E00\u9053\u4E00\u9053\u6765",
    "\u590D\u4E60\u4E0D\u662F\u91CD\u6765\uFF0C\u662F\u628A\u77E5\u8BC6\u653E\u5F97\u66F4\u7A33"
  ],
  daily: [
    "\u4ECA\u5929\u7684\u4E00\u9898\uFF0C\u9002\u5408\u73B0\u5728\u987A\u624B\u62FF\u4E0B",
    "\u4E00\u9898\u4E0D\u591A\uFF0C\u521A\u597D\u8BA9\u4ECA\u5929\u6709\u70B9\u6536\u83B7",
    "\u6BCF\u65E5\u4E00\u9898\u5DF2\u9001\u8FBE\uFF0C\u770B\u770B\u4ECA\u5929\u8003\u4EC0\u4E48",
    "\u4E00\u5206\u949F\u5C0F\u7EC3\u4E60\uFF0C\u7ED9\u77E5\u8BC6\u4FDD\u6301\u624B\u611F",
    "\u4ECA\u65E5\u4EFD\u9898\u76EE\u4E0D\u591A\uFF0C\u521A\u597D\u591F\u70ED\u8EAB",
    "\u6BCF\u5929\u89E3\u51B3\u4E00\u4E2A\u5C0F\u95EE\u53F7\uFF0C\u6162\u6162\u6512\u6210\u5E95\u6C14",
    "\u4ECA\u5929\u4E5F\u6765\u4E00\u9898\uFF0C\u8BA9\u597D\u4E60\u60EF\u4E0D\u65AD\u7EBF",
    "\u4E0D\u62FC\u9898\u91CF\uFF0C\u8BA4\u771F\u5F04\u61C2\u8FD9\u4E00\u9898\u5C31\u5F88\u597D",
    "\u6BCF\u65E5\u4E00\u9898\u5F00\u95E8\u4E86\uFF0C\u968F\u624B\u7B54\u5B8C\u518D\u5FD9",
    "\u5C0F\u5C0F\u4E00\u9898\uFF0C\u4E5F\u80FD\u5E26\u6765\u4E00\u4E2A\u5B9E\u7528\u63D0\u9192"
  ],
  gold: [
    "\u91D1\u8BC1\u5DF2\u7ECF\u5230\u624B\uFF0C\u4E0B\u4E00\u79D1\u5B89\u6392\u4E0A\uFF1F",
    "\u8FD9\u672C\u91D1\u8BC1\u5F88\u4EAE\uFF0C\u4E0B\u4E00\u672C\u4E5F\u522B\u95F2\u7740",
    "\u91D1\u8BC1\u5DF2\u6536\u597D\uFF0C\u4ECA\u5929\u60F3\u6311\u6218\u70B9\u4EC0\u4E48",
    "\u672C\u9636\u6BB5\u7A33\u7A33\u901A\u5173\uFF0C\u53BB\u770B\u770B\u4E0B\u4E00\u9879\u76EE\u6807",
    "\u91D1\u8BC1\u4E0D\u662F\u7EC8\u70B9\uFF0C\u662F\u4F60\u8BA4\u771F\u5B66\u8FC7\u7684\u8BC1\u660E",
    "\u6EE1\u7EA7\u72B6\u6001\u5728\u7EBF\uFF0C\u4E5F\u53EF\u4EE5\u8F7B\u677E\u590D\u4E60\u4E00\u4E0B",
    "\u8FD9\u4E00\u9636\u6BB5\u5DF2\u7ECF\u62FF\u4E0B\uFF0C\u7EE7\u7EED\u6309\u81EA\u5DF1\u7684\u8282\u594F\u8D70",
    "\u91D1\u8BC1\u95EA\u4EAE\u767B\u573A\uFF0C\u503C\u5F97\u53BB\u8BC1\u4E66\u5899\u770B\u4E00\u773C",
    "\u5F53\u524D\u9636\u6BB5\u5DF2\u6BD5\u4E1A\uFF0C\u4E0B\u4E00\u6B65\u7531\u4F60\u6765\u9009",
    "\u91D1\u8BC1\u5230\u624B\uFF0C\u9519\u9898\u4E5F\u53EF\u4EE5\u987A\u4FBF\u6E05\u4E00\u6E05"
  ],
  newparent: [
    "\u65B0\u624B\u7238\u5988\u63D0\u9192\uFF1A\u5B89\u5168\u6BD4\u5B8C\u7F8E\u66F4\u91CD\u8981",
    "\u5B9D\u5B9D\u6CA1\u6709\u7EDF\u4E00\u8BF4\u660E\u4E66\uFF0C\u6162\u6162\u6478\u7D22\u4E5F\u7B97\u8FDB\u6B65",
    "\u62FF\u4E0D\u51C6\u65F6\u5148\u8BB0\u5F55\u60C5\u51B5\uFF0C\u518D\u54A8\u8BE2\u4E13\u4E1A\u533B\u751F",
    "\u7167\u987E\u5B9D\u5B9D\u524D\uFF0C\u4E5F\u522B\u5FD8\u4E86\u7167\u987E\u597D\u81EA\u5DF1",
    "\u624B\u5FD9\u811A\u4E71\u5F88\u6B63\u5E38\uFF0C\u4F60\u548C\u5B9D\u5B9D\u90FD\u5728\u5B66\u4E60",
    "\u4E0D\u5FC5\u6BCF\u6B21\u90FD\u505A\u6EE1\u5206\u7238\u5988\uFF0C\u7A33\u5B9A\u966A\u4F34\u5C31\u5F88\u597D",
    "\u4ECA\u5929\u591A\u4F1A\u4E00\u62DB\uFF0C\u660E\u5929\u5C31\u5C11\u614C\u4E00\u70B9",
    "\u54ED\u58F0\u662F\u5728\u8868\u8FBE\u9700\u6C42\uFF0C\u4E0D\u662F\u5728\u7ED9\u7238\u5988\u6253\u5206",
    "\u72B6\u6001\u4E0D\u597D\u7684\u65E5\u5B50\uFF0C\u628A\u76EE\u6807\u8C03\u5C0F\u4E00\u70B9\u4E5F\u53EF\u4EE5",
    "\u4E00\u4E2A\u4EBA\u5F88\u96BE\u9762\u9762\u4FF1\u5230\uFF0C\u642D\u628A\u624B\u5C31\u662F\u597D\u961F\u53CB",
    "\u7167\u62A4\u5148\u5206\u5DE5\uFF0C\u4E34\u573A\u5C31\u80FD\u5C11\u4E00\u70B9\u624B\u5FD9\u811A\u4E71",
    "\u9047\u4E8B\u5148\u786E\u8BA4\u5B89\u5168\uFF0C\u518D\u6162\u6162\u627E\u539F\u56E0",
    "\u4E0D\u786E\u5B9A\u65F6\u5148\u505C\u4E00\u4E0B\uFF0C\u6BD4\u5306\u5FD9\u5904\u7406\u66F4\u7A33\u59A5",
    "\u5C11\u4E00\u70B9\u6A2A\u5411\u6BD4\u8F83\uFF0C\u591A\u89C2\u5BDF\u81EA\u5BB6\u5B9D\u5B9D\u7684\u8282\u594F",
    "\u5B9D\u5B9D\u7684\u4F5C\u606F\u4F1A\u53D8\u5316\uFF0C\u8BA1\u5212\u7559\u70B9\u5F39\u6027\u66F4\u8F7B\u677E",
    "\u6210\u957F\u4E0D\u662F\u76F4\u7EBF\uFF0C\u5076\u5C14\u53CD\u590D\u4E5F\u5F88\u5E38\u89C1",
    "\u628A\u5403\u7761\u548C\u72B6\u6001\u8BB0\u4E0B\u6765\uFF0C\u89C4\u5F8B\u4F1A\u66F4\u5BB9\u6613\u770B\u89C1",
    "\u5411\u4E13\u4E1A\u4EBA\u58EB\u63D0\u95EE\u65F6\uFF0C\u65F6\u95F4\u548C\u73B0\u8C61\u8D8A\u5177\u4F53\u8D8A\u597D",
    "\u6162\u534A\u62CD\u6CA1\u5173\u7CFB\uFF0C\u786E\u8BA4\u6E05\u695A\u518D\u884C\u52A8\u4E5F\u5F88\u9760\u8C31",
    "\u5148\u63A5\u4F4F\u81EA\u5DF1\u7684\u60C5\u7EEA\uFF0C\u624D\u66F4\u5BB9\u6613\u8BFB\u61C2\u5B9D\u5B9D",
    "\u89C9\u5F97\u614C\u65F6\u5148\u6DF1\u547C\u5438\uFF0C\u518D\u5904\u7406\u773C\u524D\u8FD9\u4E00\u4EF6\u4E8B",
    "\u7167\u987E\u8005\u4F11\u606F\u597D\u4E86\uFF0C\u5BB6\u5EAD\u8FD0\u8F6C\u624D\u66F4\u7A33",
    "\u9700\u8981\u5E2E\u5FD9\u5C31\u5F00\u53E3\uFF0C\u6C42\u52A9\u4E5F\u662F\u80B2\u513F\u80FD\u529B",
    "\u5B9D\u5B9D\u7EC3\u4E60\u65B0\u6280\u80FD\uFF0C\u4E5F\u9700\u8981\u7238\u5988\u7ED9\u4E00\u70B9\u65F6\u95F4",
    "\u540C\u4E00\u4E2A\u65B9\u6CD5\u4E0D\u603B\u594F\u6548\uFF0C\u8C03\u6574\u4E0D\u4EE3\u8868\u505A\u9519\u4E86",
    "\u80B2\u513F\u77E5\u8BC6\u4E0D\u7528\u4E00\u6B21\u5168\u4F1A\uFF0C\u5148\u5B66\u773C\u524D\u7528\u5F97\u4E0A\u7684",
    "\u8BFB\u61C2\u5B9D\u5B9D\u7684\u5C0F\u4FE1\u53F7\uFF0C\u6BD4\u7167\u642C\u6807\u51C6\u7B54\u6848\u66F4\u91CD\u8981",
    "\u5403\u7761\u95EE\u9898\u5148\u770B\u6574\u4F53\u72B6\u6001\uFF0C\u4E0D\u53EA\u76EF\u4E00\u6B21\u8868\u73B0",
    "\u7F51\u7EDC\u7ECF\u9A8C\u53EF\u4EE5\u53C2\u8003\uFF0C\u81EA\u5BB6\u60C5\u51B5\u8FD8\u8981\u5355\u72EC\u5224\u65AD",
    "\u53D1\u73B0\u660E\u663E\u5F02\u5E38\u6216\u6301\u7EED\u62C5\u5FC3\uFF0C\u53CA\u65F6\u54A8\u8BE2\u4E13\u4E1A\u4EBA\u5458",
    "\u5B89\u5168\u7528\u54C1\u4E5F\u8981\u5B9A\u671F\u68C0\u67E5\uFF0C\u4E0D\u662F\u88C5\u597D\u5C31\u7ED3\u675F",
    "\u7761\u524D\u5C11\u505A\u4E00\u4E2A\u51B3\u5B9A\uFF0C\u591C\u91CC\u5C31\u80FD\u5C11\u4E00\u70B9\u614C\u4E71",
    "\u5916\u51FA\u6E05\u5355\u63D0\u524D\u5907\u597D\uFF0C\u4E34\u51FA\u95E8\u80FD\u4ECE\u5BB9\u5F88\u591A",
    "\u8E72\u4E0B\u6765\u770B\u770B\u5BB6\u91CC\uFF0C\u66F4\u5BB9\u6613\u53D1\u73B0\u5B9D\u5B9D\u89C6\u89D2\u7684\u98CE\u9669",
    "\u5C0F\u7269\u4EF6\u53CA\u65F6\u6536\u597D\uFF0C\u597D\u5947\u5B9D\u5B9D\u7684\u624B\u6BD4\u60F3\u8C61\u4E2D\u5FEB",
    "\u6D17\u6FA1\u524D\u5148\u8BD5\u6C34\u6E29\uFF0C\u51C6\u5907\u9F50\u5168\u518D\u62B1\u5B9D\u5B9D\u5165\u6C34",
    "\u836F\u54C1\u548C\u6E05\u6D01\u5242\u6536\u9AD8\u5E76\u9501\u597D\uFF0C\u522B\u53EA\u4F9D\u8D56\u63D0\u9192",
    "\u62B1\u5A03\u65F6\u817E\u51FA\u4E00\u53EA\u624B\uFF0C\u624B\u673A\u6D88\u606F\u53EF\u4EE5\u7A0D\u540E\u518D\u56DE",
    "\u591C\u95F4\u7167\u62A4\u63D0\u524D\u7559\u76CF\u67D4\u5149\uFF0C\u8D77\u8EAB\u65F6\u66F4\u5B89\u5168",
    "\u80FD\u8F6E\u73ED\u5C31\u522B\u786C\u625B\uFF0C\u7761\u7720\u4E5F\u662F\u5BB6\u5EAD\u8D44\u6E90",
    "\u6C9F\u901A\u5148\u8BF4\u9700\u8981\u4EC0\u4E48\uFF0C\u6BD4\u731C\u5BF9\u65B9\u5728\u60F3\u4EC0\u4E48\u7701\u529B",
    "\u6BCF\u5929\u8BF4\u4E00\u4EF6\u505A\u5F97\u597D\u7684\u4E8B\uFF0C\u7238\u5988\u4E5F\u9700\u8981\u88AB\u80AF\u5B9A",
    "\u610F\u89C1\u4E0D\u540C\u65F6\u5148\u5BF9\u9F50\u76EE\u6807\uFF0C\u518D\u8BA8\u8BBA\u5177\u4F53\u505A\u6CD5",
    "\u522B\u5728\u6700\u7D2F\u7684\u65F6\u5019\u4E89\u8F93\u8D62\uFF0C\u5148\u4F11\u606F\u518D\u5546\u91CF",
    "\u5B9D\u5B9D\u8D1F\u8D23\u51FA\u9898\uFF0C\u7238\u5988\u8FB9\u505A\u8FB9\u5B66\u5C31\u597D",
    "\u80B2\u513F\u6CA1\u6709\u671F\u672B\u8003\uFF0C\u4ECA\u5929\u4F1A\u4E00\u70B9\u5C31\u7B97\u8FDB\u6B65",
    "\u4ECA\u5929\u7684\u76EE\u6807\u53EF\u4EE5\u5F88\u5C0F\uFF1A\u5B89\u5168\u3001\u5403\u597D\u3001\u7761\u4E00\u4F1A\u513F",
    "\u5347\u7EA7\u6162\u4E00\u70B9\u6CA1\u5173\u7CFB\uFF0C\u65B0\u624B\u6751\u672C\u6765\u5C31\u8981\u591A\u7EC3\u4E60",
    "\u7238\u5988\u4E0D\u662F\u8D85\u4EBA\uFF0C\u5076\u5C14\u6389\u7EBF\u4E5F\u9700\u8981\u5145\u7535",
    "\u6BCF\u89E3\u51B3\u4E00\u4E2A\u5C0F\u95EE\u9898\uFF0C\u4F60\u4EEC\u5C31\u66F4\u9ED8\u5951\u4E00\u70B9"
  ],
  general: [
    "\u7B2C\u4E00\u6B21\u6765\uFF1F\u5148\u8BA9\u9898\u76EE\u8BA4\u8BC6\u4E00\u4E0B\u4F60",
    "\u9898\u5E93\u6CA1\u6709\u53D8\u7B80\u5355\uFF0C\u4F60\u53EF\u4EE5\u53D8\u66F4\u7A33",
    "\u6BCF\u5929\u5B66\u4E00\u70B9\uFF0C\u5E26\u5A03\u66F4\u6709\u5E95\u6C14",
    "\u6765\u90FD\u6765\u4E86\uFF0C\u987A\u624B\u5B66\u4E00\u4E2A\u5B9E\u7528\u77E5\u8BC6\u70B9",
    "\u4E0D\u7528\u4E00\u6B21\u5B66\u5F88\u591A\uFF0C\u8BB0\u4F4F\u4E00\u4E2A\u5C31\u6709\u6536\u83B7",
    "\u5E26\u5A03\u9760\u7ECF\u9A8C\uFF0C\u4E5F\u9760\u968F\u65F6\u66F4\u65B0\u77E5\u8BC6",
    "\u4ECA\u5929\u60F3\u7EC3\u54EA\u4E00\u5757\uFF0C\u6309\u81EA\u5DF1\u7684\u8282\u594F\u6765",
    "\u6BCF\u4E00\u6B21\u8BA4\u771F\u5224\u65AD\uFF0C\u90FD\u5728\u79EF\u7D2F\u5E26\u5A03\u5E95\u6C14",
    "\u77E5\u8BC6\u70B9\u6162\u6162\u6512\uFF0C\u9047\u5230\u60C5\u51B5\u5C31\u4E0D\u5BB9\u6613\u614C",
    "\u5148\u4ECE\u4E00\u9053\u9898\u5F00\u59CB\uFF0C\u770B\u770B\u4ECA\u5929\u80FD\u5E26\u8D70\u4EC0\u4E48"
  ]
};
export {
  BATTLE_COPY,
  CERT_COPY,
  CERT_META,
  CERT_SCORE,
  CERT_SLOGAN,
  CERT_TYPES,
  CHALLENGE_MODES,
  CHALLENGE_TTL,
  DAILY_REUSE_GAP_DAYS,
  DEFAULT_STAGE,
  DISCLAIMER,
  DISCLAIMER_ITEM,
  DOMAINS,
  DOMAIN_LABELS,
  DOMAIN_QUOTA,
  EMPTY_COPY,
  ENDLESS_COPY,
  ENDLESS_DIFFICULTY_STEPS,
  ENDLESS_MAX_WRONG,
  ENDLESS_MILESTONE_STEP,
  EXAM_MODES,
  EXAM_MODE_LABELS,
  FALLBACK_WRONG_RATE_NORMAL,
  FALLBACK_WRONG_RATE_TRAP,
  FINAL_CERT_MULTIPLIER,
  FINAL_EXAM_DAILY_LIMIT,
  FINAL_EXAM_DIFFICULTY_QUOTA,
  FINAL_EXAM_QUOTA,
  FINAL_EXAM_SIZE,
  FINAL_EXAM_TYPE_QUOTA,
  FINAL_EXAM_UNLOCK_CERTS,
  HOME_GREETINGS,
  LANDING_HOOKS,
  MASTER_CERT_BONUS,
  MASTER_CERT_COPY,
  MASTER_GOLD_REQUIRED,
  MAX_CERT_SCORE,
  MAX_FRIENDS,
  MEDALS,
  MEDAL_ALLOWED_WRONG,
  MEDAL_ICONS,
  MEDAL_LABELS,
  MEDAL_RANK,
  MIN_SAMPLE_FOR_STATS,
  PAPER_DAILY_LIMIT,
  PAPER_SIZE,
  PASS_ALLOWED_WRONG,
  POSTER_HEIGHT,
  POSTER_WIDTH,
  QR_SIZE,
  QUESTION_COVERAGE_TARGETS,
  QUESTION_DIFFICULTIES,
  QUESTION_STATUSES,
  QUESTION_STATUS_LABELS,
  QUESTION_TRANSITIONS,
  QUESTION_TYPES,
  QUESTION_TYPE_LABELS,
  RECENT_PAPERS_FOR_DEDUPE,
  REVISION_ACTIONS,
  ROASTS,
  STAGES,
  STAGE_EXCLUSIVE_MIN,
  STAGE_META,
  SUBJECT_EXAM_DIFFICULTY_QUOTA,
  SUBJECT_EXAM_TYPE_QUOTA,
  SUBSCRIBE_DAILY_LIMIT,
  WRONGBOOK_MASTER_STREAK,
  answerChoices,
  calcCertScore,
  calcScore,
  canTransition,
  canUnlockFinalExam,
  canUnlockMasterCert,
  certKeyOf,
  certsUntilFinalExam,
  countStageCerts,
  encodeRankScore,
  formatDuration,
  getTier,
  getTitle,
  gradePaper,
  isAnswerCorrect,
  isDomain,
  isPassed,
  isStage,
  isStageCert,
  judgeMedal,
  monthsOfBaby,
  passScoreFor,
  pickBySeed,
  questionAnswers,
  shouldUpgrade,
  stageForMonths,
  stageLabel
};
//# sourceMappingURL=index.mjs.map